import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import React from "react";
import {Navigate, Outlet} from "react-router-dom";
import RequireAuth from "../components/auth/RequireAuth";
import PageLoading from "../components/loading/PageLoading";

export const fallbackConfig = {
    fallback : <PageLoading title="页面加载中" />
};

export const RedirectIndex = ({path}) => {
    return <Navigate to={path} replace={true} />
}

export const createComponent = (componentPath, entry) => {
    if(!componentPath.startsWith("/")){
        componentPath = "/" + componentPath;
    }

    if(entry){
       return loadable(()=>pMinDelay(import(`../entry/${entry}/pages${componentPath}/index`),200), fallbackConfig);
    }
    return loadable(()=>pMinDelay(import(`../pages${componentPath}/index`),200), fallbackConfig);
}

export const createLayout = (layoutPath) => {
    return loadable(()=>pMinDelay(import(`../layouts${layoutPath}/index`),200), fallbackConfig);
}

const RootLayout = () => {
    return (
        <Outlet />
    )
}

const createRoute = (nav, entry) => {
    let route = { path: nav.to }
    if(nav.children && nav.children.length > 0){
        let layout = <Outlet />;
        if(nav.layout){
            let LayoutContainer = createLayout(nav.layout)
            layout = <LayoutContainer />
        }
        route.element = layout;
        route.children = nav.children.filter(item=>item!=null).map(childItem=>{
            return createRoute(childItem, entry)
        })
        //如果如果子导航的第一个链接不是父链接
        if(nav.to !== route.children[0].path) {
            route.children.unshift({
                index: true,
                element: <RedirectIndex path={route.children[0].path}/>
            })
        }else{
            delete route.children[0].path;
            route.children[0].index = true;
        }
    }else{
        let componentPath = nav.component;
        let isAbsolutePage = nav.absolute || componentPath.startsWith("/");
        let Component = createComponent(componentPath, isAbsolutePage ? null : nav.entry || entry);
        if(nav.public){
           route.element = <Component />
        }else {
           route.element = <RequireAuth><Component/></RequireAuth>
        }
    }
    return route;
}

//获取路由
const createRoutes = (entry) => {
    const link = fetchLinkByEntry(entry)
    let routes = Array.isArray(link) ? link.filter(item => item != null).map(item=>createRoute(item, entry)) : [];
    return [
        {
            path: "/",
            element: <RootLayout />,
            children: routes
        }
    ]
}

export const fetchLinkByEntry = (entry) => {
    return require(`../entry/${entry}/config/link.js`).default;
}

export const fetchMenuByEntry = (entry) => {
    return require(`../entry/${entry}/config/menu.js`).default;
}

export default createRoutes;
